@switch (tipoGrafico) {
  @case ('bar') {
    <ng-container [ngTemplateOutlet]="barChart"></ng-container>
  }
  @case ('doughnut') {
    <ng-container [ngTemplateOutlet]="doughnutChart"></ng-container>
  }
}

<!-- STORAGE GRAFICO Bar -->
<ng-template #barChart>
  <div class="cnt-titolo-barchart">
    <div class="titolo-grafico">Spazio di Archiviazione</div>
    <div class="bar-chart">
      <app-chart-host chartType="bar">
        <canvas
          #barChartCanvas
          baseChart
          [data]="barChartData"
          [options]="barChartOptions"
          [type]="barChartType"
          (chartHover)="chartHovered($event)"
          (chartClick)="chartClicked($event)"
        >
        </canvas>
      </app-chart-host>
    </div>
  </div>
</ng-template>

<!-- STORAGE GRAFICO DoughnutChart -->
<ng-template #doughnutChart>
  <div class="cont-graf-torta">
    <div class="spinner-container">
      <div class="blur-background" *ngIf="spinnerDoughnutChart"></div>
      <mat-spinner [diameter]="50" *ngIf="spinnerDoughnutChart"></mat-spinner>

      <div class="cont-titolo-icon">
        <div class="titolo-grafico">Spazio di Archiviazione</div>
        <button
          class="icone-button"
          mat-icon-button
          (click)="updateStorageData()"
          [matTooltip]="'Aggiorna'"
          matTooltipPosition="above"
        >
          <mat-icon>sync</mat-icon>
        </button>
      </div>

      <div class="container-doughnutChart">
        <app-chart-host chartType="doughnut">
          <canvas
            #doughnutChartCanvas
            baseChart
            [width]="270"
            [height]="270"
            [data]="doughnutChartData"
            [type]="doughnutChartType"
            [plugins]="doughnutChartPlugins"
            (chartHover)="chartHovered($event)"
            (chartClick)="chartClicked($event)"
          >
          </canvas>
        </app-chart-host>
        <div class="dati-doughnutChart">
          <div class="legenda-sotto-grafico">
            <div class="cont-titolo-pallino">
              <span
                class="pallino"
                [ngStyle]="{ 'background-color': datiChartDoughnut.availableUsage.colore }"
              ></span>
              {{ datiChartDoughnut.availableUsage.titolo }}
            </div>
            <div>{{ datiChartDoughnut.availableUsage.valore | byteFormatter }}</div>
          </div>

          <div class="legenda-sotto-grafico">
            <div class="cont-titolo-pallino">
              <span
                class="pallino"
                [ngStyle]="{ 'background-color': datiChartDoughnut.fullUsage.colore }"
              ></span>
              {{ datiChartDoughnut.fullUsage.titolo }}
            </div>
            <div>{{ datiChartDoughnut.fullUsage.valore | byteFormatter }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
